export function getRandomUint64() {
  // Generate two 32-bit random numbers
  const high = Math.floor(Math.random() * Math.pow(2, 32));
  const low = Math.floor(Math.random() * Math.pow(2, 32));

  // Combine them to simulate a 64-bit number
  const highStr = high.toString(16).padStart(8, '0');
  const lowStr = low.toString(16).padStart(8, '0');

  // Concatenate the hex strings and convert to a decimal string
  const combinedStr = highStr + lowStr;

  // Convert the combined string to a number
  // This will be a string representation of a 64-bit number
  const result = parseInt(combinedStr, 16);

  return result;
}
